import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import TextField from 'web-app/react/components/form-elements/text-field/text-field';
import DecoratedInput from 'web-app/react/components/form-elements/containers/decorated-input/decorated-input';
import ReactOnMeta from 'web-app/react/components/form-elements/containers/react-on-meta';
export const FormInput = React.memo(function FormInput(props) {
    const { meta, input, decoration, onChange, onBlur, ...rest } = props;
    const handleChange = React.useCallback((e, name) => {
        if (onChange) {
            onChange(e);
        }
        // `name` is a vestigial passthrough for redux-form's `(event, name?)` signature; the
        // only callers (native <input> onChange via TextField/DecoratedInput) pass just the
        // event, so it is always undefined here.
        input.onChange(e, name);
    }, [onChange, input]);
    const handleBlur = React.useCallback((e) => {
        if (onBlur) {
            onBlur(e);
        }
        if (input === null || input === void 0 ? void 0 : input.onBlur) {
            input.onBlur(e);
        }
    }, [onBlur, input]);
    return (_jsx(ReactOnMeta, { ...props, children: decoration ? (_jsx(DecoratedInput, { decoration: decoration, ...rest, ...input, onChange: handleChange, onBlur: handleBlur })) : (_jsx(TextField, { ...rest, ...input, onChange: handleChange, onBlur: handleBlur })) }));
});
export default FormInput;
